import { Fragment, useEffect, useState } from "react";
import {
  Dialog,
  Disclosure,
  Menu,
  Popover,
  Transition,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import {
  ChevronDownIcon,
  FunnelIcon,
  MinusIcon,
  PlusIcon,
  Squares2X2Icon,
} from "@heroicons/react/20/solid";
import {
  useDisclosure,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link as RouterLink, useLocation } from "react-router-dom";
import { listSearchProducts } from "../actions/productActions";
import { useTranslation } from "react-i18next";
import { addItemToCart } from "../actions/cartActions";
import Loader from "../components/Loader";
import Message from "../components/Message";
import Pagination from "../components/Pagination";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addItemToWishlist,
  removeItemFromWishlist,
} from "../actions/wishListActions";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { listSizes } from "../actions/sizeActions";
import { FaRegEdit } from "react-icons/fa";
import axios from "axios";
import { serverIp } from "../config/conf";
import CartDrawer from "../components/CartDrawer";
import { ProductCard } from "../components/ProductSlider";


const sortOptions = [
  { name: "Newest", href: "#", current: false },
  { name: "Price: Low to High", href: "#", current: false },
  { name: "Price: High to Low", href: "#", current: false },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Search() {
  const filters = [
    {
      id: "category",
      name: "Category",
      options: [
        { value: "true", label: "Rings", checked: false },
        { value: "true", label: "Earrings", checked: false },
        { value: "true", label: "Pendants", checked: false },
      ],
    },
    {
      id: "color",
      name: "Plating",
      options: [
        { value: "true", label: "Yellow Gold", checked: false },
        { value: "true", label: "White Gold", checked: false },
        { value: "true", label: "Rose Gold", checked: false },
      ],
    },
    {
      id: "priceRange",
      name: "Price",
      options: [
        { value: "true", label: "Upto 2000", checked: false },
        { value: "true", label: "2000-3000", checked: false },
        { value: "true", label: "3000-5000", checked: false },
        { value: "true", label: "5000-8000", checked: false },
        { value: "true", label: "8000 and above", checked: false },
      ],
    },
    {
      id: "gender",
      name: "Gender",
      options: [
        { value: "true", label: "Women", checked: false },
        { value: "true", label: "Men", checked: false },
        { value: "true", label: "Unisex", checked: false },
      ],
    },
    {
      id: "bestOfSapphire",
      name: "Only For You",
      options: [{ value: "true", label: "Only For You", checked: false }],
    },
    {
      id: "latestArrivals",
      name: "Latest Arrivals",
      options: [{ value: "true", label: "Latest Arrivals", checked: false }],
    },
    {
      id: "giftingspecial",
      name: "Gifting Special",
      options: [{ value: "true", label: "Gifting Special", checked: false }],
    },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const routePath = useLocation();
  const onTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const queryParams = new URLSearchParams(routePath.search);
  let query = queryParams.get("q");

  const [stockCount, setStockCount] = useState(0);
  const [qty, setQty] = useState(1);
  const [id, setId] = useState("");
  const [size, setSize] = useState("0");
  // const [sizes, setSizes] = useState([]);
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [category, setCategory] = useState([]); // Use an array for multi-select
  const [subCategory, setSubCategory] = useState([]);
  const [bestOfSapphire, setBestOfSapphire] = useState([]);
  const [latest, setLatest] = useState([]);
  const [gift, setGift] = useState([]);
  const [gender, setGender] = useState([]);
  const [color, setColor] = useState([]);
  const [priceRange, setPriceRange] = useState([]);
  const [sort, setSort] = useState("");
  const [isBuyNow, setIsBuyNow] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSizeMen, setSelectedSizeMen] = useState(0);
  const [selectedSizeWomen, setSelectedSizeWomen] = useState(0);
  const [engravingTextMen, setEngravingTextMen] = useState(""); // State for engraving text
  const [engravingTextWomen, setEngravingTextWomen] = useState(""); // State for engraving text
  const [isAccordionOpen, setIsAccordionOpen] = useState(false); // State to track Accordion state
  const [backEng, setbackEng] = useState(""); // State for engraving text
  const [engImage, setengImage] = useState(""); // State for engraving text
  const [productSet, setProductSet] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItemBasePrice, setSelectedItemBasePrice] = useState([]);
  const [allowRingSize, setAllowRingSize] = useState(false);
  const [allowAnkletType, setAllowAnkletType] = useState(false);
  const [price, setPrice] = useState(0);
  const [basePrice, setBasePrice] = useState(0);
  const [isPair, setIsPair] = useState(false);
  const [allowBraceletSize, setAllowBraceletSize] = useState(false);
  const [selectedBraceletSizeMen, setSelectedBraceletSizeMen] = useState("");
  const [selectedBraceletSizeWomen, setSelectedBraceletSizeWomen] =
    useState("");

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);


  const [selectedPlating, setSelectedPlating] = useState([]);

  const [itemsPerPage, setItemsPerPage] = useState(40);

  const [scrolling, setScrolling] = useState(false);

  const [page, setPage] = useState(1);

  const [selectedAnkletSize, setSelectedAnkletSize] = useState("");
  let [isAnkletSize, setIsAnkletSize] = useState(false)


  //********** For Pet *************//

  const [frontPetTexts, setFrontPetTexts] = useState([]);
  const [petTypesSelected, setPetTypesSelected] = useState([]);
  const [backPetTexts, setBackPetTexts] = useState([]);
  const [breedAge, setBreedAge] = useState([]);
  const [breedSize, setBreedSize] = useState([]);

  const handlePetFrontEngChange = (text, index) => {
    const updated = [...frontPetTexts];
    updated[index] = text;
    setFrontPetTexts(updated);
  };

  const handlePetTypeChange = (pet, index) => {
    const updated = [...petTypesSelected];
    updated[index] = pet;
    setPetTypesSelected(updated);
  };

  const handlePetBackEngChange = (text, index) => {
    const updated = [...backPetTexts];
    updated[index] = text;
    setBackPetTexts(updated);
  };

  const handleBreedAgeChange = (text, index) => {
    const updated = [...breedAge];
    updated[index] = text;
    setBreedAge(updated);
  };

  const handleBreedSizeChange = (text, index) => {
    const updated = [...breedSize];
    updated[index] = text;
    setBreedSize(updated);
  };

  useEffect(() => {
    // console.log("selectedProduct", selectedProduct);
    if (
      selectedProduct
      &&
      selectedProduct.productCollections?.some(cat => cat.name === "Pet Collection") &&
      selectedProduct.canEngrave && selectedProduct.canBackEng
    ) {
      const q = qty || 1;

      console.log("In Pet Collection Search");

      setFrontPetTexts(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setPetTypesSelected(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push(null);
        return updated.slice(0, q);
      });

      setBackPetTexts(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setBreedAge(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setBreedSize(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });
    }
  }, [qty]);

  useEffect(() => {
    onTop();
    dispatch(listSizes());
  }, [query]);

  const handlePage = (page) => {
    onTop();
    setPage(page);
  };

  const {
    loading: loadingFilter,
    error: errorFilter,
    menuLinks: menuFilter,
  } = useSelector((state) => state.menuLinkList);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const productList = useSelector((state) => state.productList);
  const { loading, products, error } = productList;

  const productSearchList = useSelector((state) => state.productSearchList);
  const {
    loading: loadingSearch,
    error: errorSearch,
    products: productSearch,
  } = productSearchList;

  const wishList = useSelector((state) => state.wishlist);
  const { wishlistItems } = wishList;

  const sizeList = useSelector((state) => state.sizeList);
  const { loading: loadingSize, error: errorSize, sizes } = sizeList;

  const { isOpen, onOpen, onClose } = useDisclosure();

  const { i18n } = useTranslation();

  const [finalAmount, setfinalAmount] = useState(0);
  const [itemPer, setItemPer] = useState(selectedProduct?.setItemsPer || 2);

  let lang = i18n.language;

  const handleScroll = () => {
    if (window.innerWidth >= 1080 && window.scrollY > 100) {
      setScrolling(true);
    } else if (window.innerWidth <= 400 && window.scrollY > 100) {
      setScrolling(true);
    } else {
      setScrolling(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const clearFilter = () => {
    setCategory([]);
    setSubCategory([]);
    setBestOfSapphire([]);
    setLatest([]);
    setColor([]);
    setPriceRange([]);
    setSort("");
  };

  const handleAccordionToggle = (isOpen) => {
    setIsAccordionOpen(isOpen); // Toggle Accordion state
    if (!isOpen) {
      setEngravingTextMen(""); // Clear engraving text when Accordion is closed
      setEngravingTextWomen(""); // Clear engraving text when Accordion is closed
    }
  };

  const handleEngravingInput = (value, gender) => {
    const lettersAndSpaces = /^[A-Za-z ]*$/; // Regex to allow only letters and spaces
    if (lettersAndSpaces.test(value)) {
      if (gender === "female"|| gender === "unisex") {
        setEngravingTextWomen(value); // Update engraving text if input is valid
      } else {
        setEngravingTextMen(value); // Update engraving text if input is valid
      }
    }
  };

  const handleAddToCart = (obj) => {
    // e.preventDefault();
    const addToCart = () => {
      dispatch(addItemToCart(obj));
      // Check if the item exists in the wishlist
      const isInWishlist = wishlistItems?.some((item) => item._id === obj.product);

      if (isInWishlist) {
        dispatch(removeItemFromWishlist(obj.product));
      }
      onClose();
      if (isBuyNow) {
        setIsBuyNow(false);
        navigate("/cart");
      } else {
        notify("/cart", "Item Added To Cart", toast.success);
      }
    };

    // console.log("Select Product ---> ", selectedProduct);

    const categories = selectedProduct.categories?.map(c => c.name?.toLowerCase()) || [];
    const subcategories = selectedProduct.subcategories?.map(s => s.name?.toLowerCase()) || [];

    const isListString = (list) => {
      return Array.isArray(list) && list.every(item => typeof item === 'string');
    };

    const isRings = categories.includes("rings");
    const isBracelets = categories.includes("bracelets");
    const isAnklets = categories.includes("anklets");
    const isCoupleRing = subcategories.includes("couple rings");
    const isCoupleBracelets = subcategories.includes("for couples");
    const isSets = categories.includes("jewellery sets");
    const isMale = selectedProduct.gender?.toLowerCase() === "male";

    // const details = selectedProduct.product;

    if (isSets && productSet.length > 0 && productSet.length < 2) {
      notify("#", "Please Select Min 2 Items in Customized Set", toast.error);
      return;
    }

    if (isRings && isCoupleRing && (selectedSizeMen === 0 || selectedSizeWomen === 0)) {
      notify("#", "Select Both Ring Size", toast.error);
      return;
    }

    if (isRings && isMale && selectedSizeMen === 0) {
      notify("#", "Select Ring Size", toast.error);
      return;
    }

    if ((isRings ||
      (isSets && productSet.length === 0) ||
      (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIR")))
    ) && !isMale && selectedSizeWomen === 0) {
      notify("#", "Select Ring Size", toast.error);
      return;
    }

    if (
      (isAnklets ||
        (isSets && productSet.length === 0 &&
          !isListString(selectedProductDetails) &&
          selectedProduct.products?.some(e => e.sku?.includes("SAIA"))) ||
        (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIA")))
      ) && selectedAnkletSize === ""
    ) {
      notify("#", "Select Anklet Size", toast.error);
      return;
    }

    if (isBracelets && isCoupleBracelets && (selectedBraceletSizeWomen === "" || selectedBraceletSizeMen === "")) {
      notify("#", "Select Both Bracelets Size", toast.error);
      return false;
    }

    if (isBracelets && isMale && selectedBraceletSizeMen === "") {
      notify("#", "Select Bracelets Size", toast.error);
      return false;
    }

    if (
      (isBracelets ||
        (isSets && productSet.length === 0 &&
          !isListString(selectedProductDetails) &&
          selectedProduct.products?.some(e => e.sku?.includes("SAIB"))) ||
        (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIB")))
      ) && !isMale && selectedBraceletSizeWomen === ""
    ) {
      notify("#", "Select Bracelets Size", toast.error);
      return false;
    }

    if (selectedProduct.canImgEng && selectedProduct.canBackEng) {
      if (petTypesSelected.includes(null) || petTypesSelected.length === 0 || petTypesSelected.includes('')) {
        notify("#", "Please Select Breed", toast.error);
        return;
      }

      if (breedSize.includes('')) {
        notify("#", "Please Select Size", toast.error);
        return;
      }

      if (breedAge.includes('')) {
        notify("#", "Please Select Your Pet Age", toast.error);
        return;
      }

      if (frontPetTexts.includes('')) {
        notify("#", "Enter Front Engraving Characters", toast.error);
        return;
      }

      if (backPetTexts.includes('')) {
        notify("#", "Enter Back Engraving Characters", toast.error);
        return;
      }
    }

    // All validations passed — add to cart
    addToCart();

  };

  const uploadImageHandler = async (e, setImageCallback) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);
    // setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.post(
        `${serverIp}/api/uploads/single`,
        formData,
        config
      );

      // Use the passed callback to set the image URL
      setImageCallback(data);

      // setUploading(false);
    } catch (err) {
      console.error(err);
      // setUploading(false);
    }
  };

  const handleAddToCart2 = (pId) => {
    dispatch(addItemToCart(1, "1", pId, "en"));
    onClose();
    notify("/cart", "Item Added To Cart", toast.success);
  };

  const addItemToWishlistHandler = (productId) => {
    dispatch(addItemToWishlist(productId));
    notify("/wishlist", "Item Added To Wishlist", toast.success);
  };

  const removeItemFromWishlistHandler = (id) => {
    dispatch(removeItemFromWishlist(id));
    notify("/wishlist", "Item Removed from Wishlist", toast.error);
  };

  const handleSizeChange = (e) => {
    setQty(0);
    const selectedSize = e.target.value;
    setSize(selectedSize);
    const selectedSizeObj = sizes.find(
      (sizeObj) =>
        (i18n.language === "de" ? sizeObj.germanSize : sizeObj.indianSize) ===
        selectedSize
    );
    setStockCount(selectedSizeObj ? selectedSizeObj.countInStock : 0);
  };

  // const handleQuantityChange = (e) => {
  //   const selectedQuantity = Number(e.target.value);
  //   if (selectedQuantity > 0) {
  //     setQty(selectedQuantity);
  //   }
  // };

  const handleQuantityChange = (value) => {
    if (value >= 1 && value <= 5) {
      setQty(value);
    }
  };

  const handleModalOpen = (sizes, id, sent) => {
    onOpen();
    setIsBuyNow(sent);
    // setSizes(sizes);
    setId(id);
  };

  const handleCheckboxChange = (event, setStateCallback) => {
    const { value, checked, name } = event.target;

    setPage(1);

    setStateCallback((prevValues) => {
      if (
        name === "Only For You" ||
        name === "Latest Arrivals" ||
        name === "Gifting Special"
      ) {
        if (checked) {
          return [...prevValues, value];
        } else {
          return prevValues.filter((item) => item !== value);
        }
      } else {
        if (checked) {
          return [...prevValues, name];
        } else {
          return prevValues.filter((item) => item !== name);
        }
      }
    });
  };

  const notify = (link, content, type) =>
    type(<RouterLink to={link}>{content}</RouterLink>);

  const indexOfLastItem = page * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  function filterProducts() {
    const filteredProducts = productSearch?.filter((product) => {
      if (category.length > 0 && !category.includes(product.category)) {
        return false;
      }
      if (color.length > 0 && !color.includes(product.plating)) {
        return false;
      }
      if (priceRange.length > 0) {
        const priceRangeValue = parseInt(product.discountedPrice);
        return priceRange.some((selectedRange) => {
          if (selectedRange === "Upto 2000") {
            return priceRangeValue <= 2000;
          } else if (selectedRange === "2000-3000") {
            return priceRangeValue >= 2000 && priceRangeValue <= 3000;
          } else if (selectedRange === "3000-5000") {
            return priceRangeValue >= 3000 && priceRangeValue <= 5000;
          } else if (selectedRange === "5000-8000") {
            return priceRangeValue >= 5000 && priceRangeValue <= 8000;
          } else if (selectedRange === "8000 and above") {
            return priceRangeValue >= 8000;
          }
          return false;
        });
      }

      if (gender.length > 0 && !gender.includes(product.gender)) {
        return false;
      }
      if (
        bestOfSapphire.length > 0 &&
        !bestOfSapphire.includes(product.bestOfSapphire?.toString())
      ) {
        return false;
      }
      if (
        latest.length > 0 &&
        !latest.includes(product.latestArrivals?.toString())
      ) {
        return false;
      }
      if (gift.length > 0 && !gift.includes(product.gift?.toString())) {
        return false;
      }
      return true;
    });

    if (sort === "Newest") {
      filteredProducts.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
    } else if (sort === "Price: Low to High") {
      filteredProducts.sort((a, b) => a.discountedPrice - b.discountedPrice);
    } else if (sort === "Price: High to Low") {
      filteredProducts.sort((a, b) => b.discountedPrice - a.discountedPrice);
    }

    return filteredProducts?.slice(indexOfFirstItem, indexOfLastItem);
  }
  const currentItems = filterProducts();

  useEffect(() => {
    dispatch(listSearchProducts(query));
  }, [query]);


  const totalPrice = selectedItems.reduce((sum, item) => {
    const price = item.sku.includes("SAIA")
      ? isPair
        ? item.itemPrice * 2
        : item.itemPrice
      : item.itemPrice;
    return sum + price;
  }, 0);

  const totalBasePrice = selectedItemBasePrice.reduce((sum, item) => {
    const basePrice = item.sku.includes("SAIA")
      ? isPair
        ? item.itemBasePrice * 2
        : item.itemBasePrice
      : item.itemBasePrice;
    return sum + basePrice;
  }, 0);

  useEffect(() => {
    let overallDiscount = Number(
      (
        ((selectedProduct?.basePrice - selectedProduct?.price) /
          selectedProduct?.basePrice) *
        100
      )?.toFixed(0)
    );

    if (selectedItems.length < 2) {
      // console.log(totalPrice);
      setfinalAmount(totalPrice);
    } else {
      // console.log("total price", totalBasePrice);
      let extraDiscount = (selectedItemBasePrice.length - 1) * itemPer;
      let finalDiscount = overallDiscount + extraDiscount;
      let discountedPrice = Number(
        (totalBasePrice - (totalBasePrice * finalDiscount) / 100).toFixed(0)
      );

      setfinalAmount(discountedPrice);
    }
  }, [selectedItemBasePrice, isPair]);

  // const totalPrice = selectedItems.reduce((sum, price) => sum + price, 0);

  // const totalBasePrice = selectedItemBasePrice.reduce(
  //   (sum, price) => sum + price,
  //   0
  // );

  const selectedProductDetails = {
    name: selectedProduct?.name,
    image:
      selectedProduct?.variants?.length > 0 &&
      selectedProduct?.variants?.filter((variant) =>
        selectedPlating.length > 0
          ? selectedPlating.includes(variant.color)
          : variant.isPrimary
      )[0]?.images[0],
    qty,
    sizeMen: selectedSizeMen,
    sizeWomen: selectedSizeWomen,
    price:
      productSet.length > 0
        ? finalAmount
        : selectedProduct?.products?.some((item) => item?.sku?.includes("SAIA"))
          ? price
          : selectedProduct?.price,
    basePrice:
      productSet.length > 0
        ? totalBasePrice
        : selectedProduct?.products?.some((item) => item?.sku?.includes("SAIA"))
          ? basePrice
          : selectedProduct?.basePrice,
    product: selectedProduct?._id,
    products: productSet,
    variant:
      selectedProduct?.variants?.length > 0 &&
      selectedProduct?.variants?.filter((variant) => variant?.isPrimary)[0]
        ?._id,
    sku: selectedProduct?.sku,
    giftWrap: false,
    message: "",
    engraveMen: engravingTextMen,
    engraveWomen: engravingTextWomen,
    isPair,
    braceletsSizeMen:
      selectedBraceletSizeMen,
    braceletsSizeWomen:
      selectedBraceletSizeWomen,
    ankletsSize: selectedAnkletSize,
    petFrontEng: frontPetTexts,
    petBackEng: backPetTexts,
    petEngImage: petTypesSelected,
    breedAge: breedAge,
    breedSize: breedSize,
  };

  // console.log("search", selectedProduct);

  return (
    <div className="bg-white">
      <div>
        <Transition.Root show={mobileFiltersOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-40 lg:hidden"
            onClose={setMobileFiltersOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 z-40 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="relative ml-auto flex h-full w-full max-w-xs flex-col overflow-y-auto bg-white py-4 pb-12 shadow-xl">
                  <div className="flex items-center justify-between px-4">
                    <h2 className="text-lg font-medium text-gray-900">
                      Filters
                    </h2>
                    <button
                      type="button"
                      className="-mr-2 flex h-10 w-10 items-center justify-center rounded-md bg-white p-2 text-gray-400"
                      onClick={() => setMobileFiltersOpen(false)}
                    >
                      <span className="sr-only">Close menu</span>
                      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>

                  <form className="mt-4 border-t border-gray-200">
                    {menuFilter
                      .filter((menu) => menu.name === "Generic")
                      .map((menu, index) => (
                        <div key={index}>
                          {menu.sublinks?.map((menuObj, index) => (
                            <Disclosure
                              key={index}
                              defaultOpen
                              as="div"
                              className="border-b border-gray-200"
                            >
                              {({ open }) => (
                                <>
                                  <h3 className="flow-root">
                                    <Disclosure.Button className="flex w-full items-center justify-between bg-white p-2 text-sm text-gray-400 hover:text-gray-500">
                                      <span className="text-md font-semibold text-gray-900">
                                        {menuObj.Head}
                                      </span>
                                      <span className="ml-6 flex items-center">
                                        {open ? (
                                          <MinusIcon
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                          />
                                        ) : (
                                          <PlusIcon
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                          />
                                        )}
                                      </span>
                                    </Disclosure.Button>
                                  </h3>
                                  <Disclosure.Panel className="py-4 px-2 bg-white">
                                    <div className="space-y-4">
                                      {menuObj.sublinkObj?.map(
                                        (option, idx) => (
                                          <div
                                            key={idx}
                                            className="flex items-center"
                                          >
                                            <input
                                              id={option.name}
                                              name={option.name}
                                              defaultValue={option.name}
                                              type="checkbox"
                                              checked={
                                                menuObj.Head === "Purpose"
                                                  ? subCategory.includes(
                                                    option.name
                                                  )
                                                  : menuObj.Head === "Plating"
                                                    ? color.includes(option.name)
                                                    : menuObj.Head === "Category"
                                                      ? category.includes(
                                                        option.name
                                                      )
                                                      : menuObj.Head === "Gender"
                                                        ? gender.includes(option.name)
                                                        : priceRange.includes(
                                                          option.name
                                                        )
                                              }
                                              onChange={(e) => {
                                                if (
                                                  menuObj.Head === "Purpose"
                                                ) {
                                                  handleCheckboxChange(
                                                    e,
                                                    setSubCategory
                                                  );
                                                } else if (
                                                  menuObj.Head === "Plating"
                                                ) {
                                                  handleCheckboxChange(
                                                    e,
                                                    setColor
                                                  );
                                                } else if (
                                                  menuObj.Head === "Price"
                                                ) {
                                                  handleCheckboxChange(
                                                    e,
                                                    setPriceRange
                                                  );
                                                } else if (
                                                  menuObj.Head === "Category"
                                                ) {
                                                  handleCheckboxChange(
                                                    e,
                                                    setCategory
                                                  );
                                                } else if (
                                                  menuObj.Head === "Gender"
                                                ) {
                                                  handleCheckboxChange(
                                                    e,
                                                    setGender
                                                  );
                                                }
                                              }}
                                              className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                            />
                                            <label
                                              htmlFor={option.name}
                                              className="ml-3 text-sm text-gray-600"
                                            >
                                              {option.name}
                                            </label>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </Disclosure.Panel>
                                </>
                              )}
                            </Disclosure>
                          ))}
                        </div>
                      ))}
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>

        <div
          className={`flex w-full bg-white items-baseline justify-between border-b border-gray-200 px-2 md:px-14 py-4 ${scrolling ? "fixed z-10 top-[48px] md:top-[60px]" : ""
            }`}
        >
          <form className="hidden lg:flex w-full">
            <div className="flex w-full gap-4">
              {menuFilter
                .filter((menu) => menu.name === "Generic")
                .map((menu, index) => (
                  <div className="flex gap-4" key={index}>
                    {menu.sublinks?.map((menuObj, index) => (
                      <Popover key={index} as="div" className="">
                        {({ open }) => (
                          <>
                            <h3 className="flow-root">
                              <Popover.Button className="relative flex w-full items-center justify-between bg-white p-2 text-sm text-gray-400 hover:text-gray-500">
                                <span className="text-md font-semibold text-gray-900">
                                  {menuObj.Head}
                                </span>
                                <span className="ml-2 mr-4 flex items-center">
                                  {open ? (
                                    <IoIosArrowUp
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    <IoIosArrowDown
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  )}
                                </span>
                              </Popover.Button>
                            </h3>
                            <Popover.Panel className="absolute z-20 py-4 px-2 bg-white border shadow-md">
                              <div className="space-y-4">
                                {menuObj.sublinkObj?.map((option, idx) => (
                                  <div key={idx} className="flex items-center ">
                                    <input
                                      id={option.name}
                                      name={option.name}
                                      defaultValue={option.name}
                                      type="checkbox"
                                      checked={
                                        menuObj.Head === "Purpose"
                                          ? subCategory.includes(option.name)
                                          : menuObj.Head === "Plating"
                                            ? color.includes(option.name)
                                            : menuObj.Head === "Category"
                                              ? category.includes(option.name)
                                              : menuObj.Head === "Gender"
                                                ? gender.includes(option.name)
                                                : priceRange.includes(option.name)
                                      }
                                      onChange={(e) => {
                                        if (menuObj.Head === "Purpose") {
                                          handleCheckboxChange(
                                            e,
                                            setSubCategory
                                          );
                                        } else if (menuObj.Head === "Plating") {
                                          handleCheckboxChange(e, setColor);
                                        } else if (menuObj.Head === "Price") {
                                          handleCheckboxChange(
                                            e,
                                            setPriceRange
                                          );
                                        } else if (
                                          menuObj.Head === "Category"
                                        ) {
                                          handleCheckboxChange(e, setCategory);
                                        } else if (menuObj.Head === "Gender") {
                                          handleCheckboxChange(e, setGender);
                                        }
                                      }}
                                      className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                    />
                                    <label
                                      htmlFor={option.name}
                                      className="ml-3 text-sm text-gray-600"
                                    >
                                      {option.name}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </Popover.Panel>
                          </>
                        )}
                      </Popover>
                    ))}
                  </div>
                ))}
            </div>
          </form>

          <div className="flex w-full md:w-auto justify-end items-center">
            <Menu as="div" className="relative inline-block text-left">
              <div>
                <Menu.Button className="inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                  Sort
                  <ChevronDownIcon
                    className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 hover:text-gray-500"
                    aria-hidden="true"
                  />
                </Menu.Button>
              </div>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="py-1">
                    {sortOptions.map((option, idx) => (
                      <Menu.Item key={idx}>
                        {({ active }) => (
                          <button
                            onClick={() => setSort(option.name)}
                            className={classNames(
                              option.current
                                ? "font-medium text-gray-900"
                                : "text-gray-500",
                              active ? "bg-gray-100" : "",
                              "block px-4 py-2 text-sm"
                            )}
                          >
                            {option.name}
                          </button>
                        )}
                      </Menu.Item>
                    ))}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>

            <button
              type="button"
              className="-m-2 ml-5 p-2 text-gray-400 hover:text-gray-500 sm:ml-7"
              onClick={() => {
                setToggle(!toggle);
                setItemsPerPage(toggle ? 40 : 40);
              }}
            >
              <span className="sr-only">View grid</span>
              <Squares2X2Icon className="h-5 w-5" aria-hidden="true" />
            </button>
            <button
              type="button"
              className="-m-2 ml-4 p-2 text-gray-400 hover:text-gray-500 sm:ml-6 lg:hidden"
              onClick={() => {
                setMobileFiltersOpen(true);
              }}
            >
              <span className="sr-only">Filters</span>
              <FunnelIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
        </div>

        <main id="prodPage" className="mx-auto max-w-7xl">
          <section aria-labelledby="products-heading" className="pb-12 pt-6">
            <h2 id="products-heading" className="sr-only">
              Products
            </h2>

            <div className="md:min-h-[112vh]">
              <div className="">
                <div className="bg-white">
                  <div className="mx-auto max-w-2xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                    <h2 className="sr-only">Products</h2>

                    {loadingSearch ? (
                      <div>
                        <Loader />
                      </div>
                    ) : errorSearch ? (
                      <div>
                        <Message type="error">{errorSearch}</Message>
                      </div>
                    ) : (
                      <div
                        className={`relative grid mt-4 md:gap-x-2 gap-y-4 grid-cols-2 md:grid-cols-4 lg:grid-cols-5`}
                      >
                        {currentItems?.map((product, index) => (
                          // <div
                          //   key={index}
                          //   className="flex flex-col justify-between relative p-2 group/prod"
                          // >
                          //   <RouterLink
                          //     to={`/product/${product.name?.replaceAll(
                          //       " ",
                          //       "-"
                          //     )}/${product._id}?variant=${product?.variants?.length > 0 &&
                          //     product?.variants?.filter((variant) =>
                          //       selectedPlating.length > 0
                          //         ? selectedPlating.includes(variant.color)
                          //         : variant.isPrimary
                          //     )[0]?._id
                          //       }`}
                          //   >
                          //     <div className="aspect-h-1 aspect-w-1 overflow-hidden bg-white">
                          //       {product?.variants?.length > 0 ? (
                          //         <img
                          //           src={
                          //             product?.variants?.length > 0 &&
                          //             product?.variants?.filter((variant) =>
                          //               selectedPlating.length > 0
                          //                 ? selectedPlating.includes(
                          //                   variant.color
                          //                 )
                          //                 : variant.isPrimary
                          //             )[0]?.images[0]
                          //           }
                          //           alt={product?.name}
                          //           loading="lazy"
                          //           className={
                          //             "self-center hover:scale-125 transition-transform ease-in object-cover object-center m-auto bg-[#EBEAE5] text-center"
                          //           }
                          //         />
                          //       ) : (
                          //         <div className="flex h-full w-full bg-gray-100 items-center justify-center">
                          //           <span>Image</span>
                          //         </div>
                          //       )}
                          //     </div>
                          //     <h3 className="py-1 mt-3 text-center px-2 text-base font-semibold text-gray-800 h-6 overflow-clip line-clamp-2">
                          //       {product.name}
                          //     </h3>
                          //     {/* <h3 className="py-1 mt-3 text-center px-2 text-[14px] text-gray-500 h-6 overflow-clip truncate">
                          //     {product.metaDescription}
                          //   </h3> */}
                          //     <div className="flex flex-col mt-3 px-2 gap-2 md:gap-4 justify-between items-center">
                          //       <div className="flex w-full items-center justify-center gap-1 md:gap-3 ">
                          //         <p className="text-[14px] text-center text-gray-400 line-through">
                          //           ₹{" "}
                          //           {product.basePrice?.toLocaleString("en-IN")}
                          //         </p>
                          //         <p className="text-[14px] text-center md:text-base font-semibold text-[#000080]">
                          //           {(
                          //             ((product.basePrice - product.price) /
                          //               product.basePrice) *
                          //             100
                          //           ).toFixed(0)}
                          //           %
                          //         </p>
                          //       </div>
                          //       <div className="flex w-full items-center justify-center gap-1 md:gap-3">
                          //         <p className="text-sm text-center md:text-base font-bold text-gray-900">
                          //           ₹ {product.price?.toLocaleString("en-IN")}
                          //         </p>
                          //       </div>
                          //     </div>
                          //   </RouterLink>
                          //   {/* <div className="w-full pt-2 bg-white hidden group-hover/prod:block"> */}
                          //   <div className="absolute left-0 -bottom-10 w-full flex items-center bg-white opacity-100 md:opacity-0 md:group-hover/prod:opacity-100 transition-opacity duration-300">
                          //     {/* //hidden group-hover/prod: */}
                          //     <div className="flex w-full justify-between items-center gap-1 h-[40px]">
                          //       {product?.categories?.some(
                          //         (cat) => cat.name === "Rings" ||
                          //           cat.name === "BRACELETS" ||
                          //           cat.name === "ANKLETS" ||
                          //           cat.name === "JEWELLERY SETS"
                          //       ) || product?.canEngrave ? (
                          //         <button
                          //           className="w-3/4 h-full bg-[#000080] rounded text-center self-center text-white text-sm font-medium"
                          //           onClick={() => {
                          //             if (userInfo && userInfo.firstName) {
                          //               onOpen();
                          //               setSelectedProduct(product);
                          //             } else {
                          //               navigate(
                          //                 `/signup?redirect=/product/${product.name?.replaceAll(
                          //                   " ",
                          //                   "-"
                          //                 )}/${product._id}?variant=${product?.variants?.length > 0 &&
                          //                 product?.variants?.filter(
                          //                   (variant) =>
                          //                     selectedPlating.length > 0
                          //                       ? selectedPlating.includes(
                          //                         variant.color
                          //                       )
                          //                       : variant.isPrimary
                          //                 )[0]?._id
                          //                 }`
                          //               );
                          //             }
                          //           }}
                          //         >
                          //           Add to Cart
                          //         </button>
                          //       ) : (
                          //         <button
                          //           className="w-3/4 h-full bg-[#000080] rounded text-center self-center text-white text-sm font-medium"
                          //           onClick={(e) => {
                          //             if (userInfo && userInfo.firstName) {
                          //               handleAddToCart(e, {
                          //                 name: product?.name,
                          //                 image:
                          //                   product?.variants?.length > 0 &&
                          //                   product?.variants?.filter(
                          //                     (variant) =>
                          //                       selectedPlating.length > 0
                          //                         ? selectedPlating.includes(
                          //                           variant.color
                          //                         )
                          //                         : variant.isPrimary
                          //                   )[0]?.images[0],
                          //                 qty,
                          //                 sizeMen: "1",
                          //                 sizeWomen: "1",
                          //                 price:
                          //                   productSet.length > 0
                          //                     ? finalAmount
                          //                     : product?.products?.some(
                          //                       (item) =>
                          //                         item.sku.includes("SAIA")
                          //                     )
                          //                       ? price
                          //                       : product.price,
                          //                 basePrice:
                          //                   productSet.length > 0
                          //                     ? totalBasePrice
                          //                     : product?.products?.some(
                          //                       (item) =>
                          //                         item.sku.includes("SAIA")
                          //                     )
                          //                       ? basePrice
                          //                       : product.basePrice,
                          //                 product: product._id,
                          //                 products: productSet,
                          //                 variant:
                          //                   product?.variants?.length > 0 &&
                          //                   product?.variants?.filter(
                          //                     (variant) => variant?.isPrimary
                          //                   )[0]?._id,
                          //                 sku: product?.sku,
                          //                 giftWrap: false,
                          //                 message: "",
                          //                 engraveMen: engravingTextMen,
                          //                 engraveWomen: engravingTextWomen,
                          //                 isPair,
                          //                 braceletsSizeMen:
                          //                   selectedBraceletSizeMen,
                          //                 braceletsSizeWomen:
                          //                   selectedBraceletSizeWomen,
                          //                 ankletsSize: selectedAnkletSize,
                          //                 petFrontEng: frontPetTexts,
                          //                 petBackEng: backPetTexts,
                          //                 petEngImage: petTypesSelected,
                          //                 breedAge: breedAge,
                          //                 breedSize: breedSize,
                          //               });
                          //             } else {
                          //               navigate(
                          //                 `/signup?redirect=/product/${product.name?.replaceAll(
                          //                   " ",
                          //                   "-"
                          //                 )}/${product._id}?variant=${product?.variants?.length > 0 &&
                          //                 product?.variants?.filter(
                          //                   (variant) =>
                          //                     selectedPlating.length > 0
                          //                       ? selectedPlating.includes(
                          //                         variant.color
                          //                       )
                          //                       : variant.isPrimary
                          //                 )[0]?._id
                          //                 }`
                          //               );
                          //             }
                          //           }}
                          //         >
                          //           Add to Cart
                          //         </button>
                          //       )}

                          //       <button
                          //         className="flex items-center justify-center w-1/4 h-full border border-[#000080] rounded"
                          //         onClick={() => {
                          //           wishlistItems?.some(
                          //             (item) => item._id === product._id
                          //           )
                          //             ? removeItemFromWishlistHandler(
                          //               product._id
                          //             )
                          //             : addItemToWishlistHandler(product._id);
                          //         }}
                          //       >
                          //         <Icon
                          //           as={
                          //             wishlistItems?.some(
                          //               (item) => item._id === product._id
                          //             )
                          //               ? AiFillHeart
                          //               : AiOutlineHeart
                          //           }
                          //           w="6"
                          //           h="6"
                          //           textColor="#000080"
                          //           cursor="pointer"
                          //         />
                          //       </button>
                          //     </div>
                          //   </div>
                          // </div>
                          <ProductCard
                            prod={product}
                            key={index}
                            setSelectedProduct={setSelectedProduct}
                            onOpen={onOpen}
                            setIsBuyNow={setIsBuyNow}
                            navigate={navigate}
                            userInfo={userInfo}
                            windowWidth={windowWidth} />
                        ))}

                        <CartDrawer
                          isOpen={isOpen}
                          onClose={onClose}
                          selectedProductDetails={selectedProductDetails}
                          handleAddToCart={handleAddToCart}
                          qty={qty}
                          handleQuantityChange={handleQuantityChange}
                          selectedProduct={selectedProduct}
                          productSet={productSet}
                          setProductSet={setProductSet}
                          selectedPlating={selectedPlating}
                          sizes={sizes}
                          loadingSize={loadingSize}
                          errorSize={errorSize}
                          selectedSizeMen={selectedSizeMen}
                          setSelectedSizeMen={setSelectedSizeMen}
                          selectedSizeWomen={selectedSizeWomen}
                          setSelectedSizeWomen={setSelectedSizeWomen}
                          selectedAnkletSize={selectedAnkletSize}
                          setSelectedAnkletSize={setSelectedAnkletSize}
                          isPair={isPair}
                          setIsPair={setIsPair}
                          selectedBraceletSizeMen={selectedBraceletSizeMen}
                          setSelectedBraceletSizeMen={setSelectedBraceletSizeMen}
                          selectedBraceletSizeWomen={selectedBraceletSizeWomen}
                          setSelectedBraceletSizeWomen={setSelectedBraceletSizeWomen}
                          allowRingSize={allowRingSize}
                          setAllowRingSize={setAllowRingSize}
                          allowBraceletSize={allowBraceletSize}
                          setAllowBraceletSize={setAllowBraceletSize}
                          allowAnkletType={allowAnkletType}
                          setAllowAnkletType={setAllowAnkletType}
                          selectedItems={selectedItems}
                          setSelectedItems={setSelectedItems}
                          selectedItemBasePrice={selectedItemBasePrice}
                          setSelectedItemBasePrice={setSelectedItemBasePrice}
                          totalPrice={totalPrice}
                          totalBasePrice={totalBasePrice}
                          engravingTextMen={engravingTextMen}
                          engravingTextWomen={engravingTextWomen}
                          handleEngravingInput={handleEngravingInput}
                          isAccordionOpen={isAccordionOpen}
                          handleAccordionToggle={handleAccordionToggle}
                          uploadImageHandler={uploadImageHandler}
                          petTypesSelected={petTypesSelected}
                          handlePetTypeChange={handlePetTypeChange}
                          frontPetTexts={frontPetTexts}
                          handlePetFrontEngChange={handlePetFrontEngChange}
                          backPetTexts={backPetTexts}
                          handlePetBackEngChange={handlePetBackEngChange}
                          breedAge={breedAge}
                          handleBreedAgeChange={handleBreedAgeChange}
                          breedSize={breedSize}
                          handleBreedSizeChange={handleBreedSizeChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
          {loading ? (
            <></>
          ) : error ? (
            <></>
          ) : (
            <Pagination
              page={page}
              setPage={setPage}
              handlePage={handlePage}
              totalItems={productSearch?.length}
              itemsPerPage={itemsPerPage}
            ></Pagination>
          )}
        </main>
      </div>
    </div>
  );
}
